import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// Estilos base (frameworks)
import "./assets/css/divisan-tokens.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./assets/vendor/aos/aos.css";

// Estado global
import { createPinia } from "pinia";
import piniaPersistedstate from "pinia-plugin-persistedstate";

const app = createApp(App);

// Pinia
const pinia = createPinia();
pinia.use(piniaPersistedstate);

// Plugins
app.use(pinia);
app.use(router);

// Mount
app.mount("#app");
